<script>
import html2canvas from "html2canvas";
import { createQrCode } from "@/api/modules/common";

export default {
  name: "customShare",
  props: {
    value: {
      default: false,
    },
    articleData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {},
  data() {
    return {
      show: false,
      url: null,
      toDataURL: "",
    };
  },
  watch: {
    value(newValue) {
      this.show = newValue;
    },
    articleData: {
      async handler() {
        if (this.articleData.title) {
          const response = await createQrCode({
            page: "pages/index/index",
            scene: this.$route.fullPath,
          });
          if (response.data.startsWith("data:image/png;base64,")) {
            this.url = response.data;
          } else {
            // 如果不包含前缀，手动添加
            this.url = `data:image/png;base64,${response.data}`;
          }

          this.$nextTick(() => {
            this.getHtml2Canvas();
          });
        }
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("input", false);
    },
    getHtml2Canvas() {
      const content = "#printJS-form";
      html2canvas(document.querySelector(content), {
        allowTaint: false,
        useCORS: false,
        height: document.querySelector(content).outerHeight,
        width: document.querySelector(content).outerWidth,
        windowWidth: document.body.scrollWidth,
        windowHeight: document.body.scrollHeight,
        backgroundColor: "#018ED6FF",
        scale: 3,
      })
        .then(async (canvas) => {
          const roundedCanvas = document.createElement("canvas");
          const roundedContext = roundedCanvas.getContext("2d");
          const radius = 40; // 圆角半径

          roundedCanvas.width = canvas.width;
          roundedCanvas.height = canvas.height;

          roundedContext.beginPath();
          roundedContext.moveTo(radius, 0);
          roundedContext.lineTo(canvas.width - radius, 0);
          roundedContext.quadraticCurveTo(
            canvas.width,
            0,
            canvas.width,
            radius
          );
          roundedContext.lineTo(canvas.width, canvas.height - radius);
          roundedContext.quadraticCurveTo(
            canvas.width,
            canvas.height,
            canvas.width - radius,
            canvas.height
          );
          roundedContext.lineTo(radius, canvas.height);
          roundedContext.quadraticCurveTo(
            0,
            canvas.height,
            0,
            canvas.height - radius
          );
          roundedContext.lineTo(0, radius);
          roundedContext.quadraticCurveTo(0, 0, radius, 0);
          roundedContext.closePath();
          roundedContext.clip();
          roundedContext.drawImage(canvas, 0, 0);

          const toDataURL = roundedCanvas.toDataURL("image/png");

          this.toDataURL = toDataURL;
          // let pageBlob = dataURLtoBlob(toDataURL)
          // let params = new FormData()
          // let fileOfBlob = new File([pageBlob], new Date().getTime() + '.png')
          // params.append('image', fileOfBlob)
          // // const byteCharacters = atob(toDataURL.split(',')[1])
          // // const byteNumbers = new Array(byteCharacters.length)
          // // for (let i = 0; i < byteCharacters.length; i++) {
          // //   byteNumbers[i] = byteCharacters.charCodeAt(i)
          // // }
          // // const byteArray = new Uint8Array(byteNumbers)
          // // let url = window.URL.createObjectURL(new Blob([byteArray], { type: 'image/png' }))
          // // console.log(url)
          // // let link = document.createElement('a') //创建a标签
          // // link.style.display = 'none' //将a标签隐藏
          // // link.href = url //给a标签添加下载链接
          // // link.setAttribute('download', '运行结果图片')
          // // document.body.appendChild(link)
          // // link.click() //执行a标签
          // const {data: imgData} = await uploadImgFn(params)
          // const {data} = await uploadDataFn(
          //     {
          //       ...formValue,
          //       "imageUrl": imgData.path
          //     }
          // )
          // uploadLoading.value = false
          // fn(data)
        })

        .catch(() => {
          // uploadLoading.value = false
        });
    },
  },
};
</script>

<template>
  <div class="customShare">
    <div class="content flex-center column" id="printJS-form">
      <div class="top flex-center">
        <img style="width: 220px" src="@/assets/img/logoQr.jpg" alt="" />
      </div>
      <!--        <div class="pb-8">请手动截屏，保存分享二维码</div>-->
      <div
        style="
          background-color: white;
          padding: 20px 12px;
          box-sizing: border-box;
          width: 100%;
        "
        class=" "
      >
        <div class="title flex-center" v-if="userInfoGetter.user?.name">
          【{{ userInfoGetter.user?.name }}】邀请您一起学：
        </div>
        <div class="title flex-center">{{ articleData.title }}</div>
        <div class="flex-center" v-if="url">
          <img style="width: 200px" :src="url" alt="" />
          <!--          <VueQr :text="url"></VueQr>-->
        </div>
        <div class="flex-center" style="color: #018ed6ff; font-size: 12px">
          长按或扫描二维码应急技能一起学
        </div>
      </div>
      <div style="font-size: 13px; color: white; padding: 10px 0">
        壹基金安全家园计划应急志愿者学习平台
      </div>
    </div>
    <van-popup v-model="show" @close="close">
      <img style="width: 310px" :src="toDataURL" alt="" />
    </van-popup>
  </div>
</template>

<style scoped lang="scss">
.customShare {
  position: relative;

  ::v-deep .van-popup {
    background-color: rgba(1, 142, 214, 0);
    border-radius: 0;
  }

  .content {
    position: fixed;
    z-index: -100;
    overflow: hidden;
    width: 310px;
    background-color: #018ed6ff;
    border-radius: 12px;
    box-sizing: border-box;
    bottom: -5000px;

    .top {
      font-size: 42px;
      color: #fff;
      font-weight: bold;
    }

    .title {
      color: #018ed6ff;
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>
